import React from 'react';
import {connect} from 'react-redux';
import {PlayersList as BasePlayersList} from 'desktop/sports/lol/players-list/classic';

class PlayersList extends BasePlayersList {
    getSearchConditions() {
        return {
            ...this.getSearchRuleByMode(),
            ...this.getSearchRuleByPosition(),
            ...this.getSearchRuleByPlayerName(),
            ...this.getSearchRuleByTeamName(),
        };
    }
}

function mapStatesToProps(state) {
    const {sportConfig, reset, playersLock, userPointsType, modesConfig} = state;
    const {players, filters: playersFilter, mlbFilters} = state.playersData;
    return {
        players,
        playersFilter,
        playersLock,
        sportConfig,
        mlbFilters,
        reset,
        userPointsType,
        modesConfig,
    };
}

let Table = connect(mapStatesToProps)(PlayersList);

export {Table};
